Object.defineProperty(exports,"__esModule",{value:true});var SITE_USER_TYPES=exports.SITE_USER_TYPES={
CONTACT:'Contact',
VISITOR:'Visitor'};


//////////////////
// WEBPACK FOOTER
// ../~/inbox-common/dist/constants.js
// module id = 785
// module chunks = 0